import { Button, Spin, Tooltip } from "antd";
import { WhatsAppOutlined, CheckCircleOutlined, AndroidOutlined } from "@ant-design/icons";

export const WhatsAppButton = ({ esperandoSMS, telefono, onEnviar }) => {
  const getIcon = () => {
    if (esperandoSMS === 2) return <CheckCircleOutlined />;
    if (esperandoSMS === 1) return <Spin size="small" />;
    return <WhatsAppOutlined />;
  };

  return (
    <Tooltip title="Solo Android">
      <Button
        icon={getIcon()}
        block
        size="large"
        onClick={onEnviar}
        disabled={!telefono || esperandoSMS === 1}
        style={{
          backgroundColor: esperandoSMS === 2 ? "#52c41a" : "#25D366",
          borderColor: esperandoSMS === 2 ? "#52c41a" : "#25D366",
          color: "white",
        }}
      >
        {esperandoSMS === 1 ? "Esperando..." : esperandoSMS === 2 ? "Ubicación recibida" : <>Enviar por WhatsApp <AndroidOutlined /></>}
      </Button>
    </Tooltip>
  );
};
